import { about } from '../content/site';
import SectionHeading from './SectionHeading';

export default function About() {
  return (
    <section id="about" className="bg-cream py-24">
      <div className="container-page grid gap-12 md:grid-cols-2 md:items-start">
        <SectionHeading eyebrow={about.eyebrow} heading={about.heading} />

        <div>
          {about.paragraphs.map((p) => (
            <p key={p} className="mb-4 text-base leading-relaxed text-ink-soft last:mb-0">
              {p}
            </p>
          ))}

          <dl className="mt-8 grid grid-cols-3 gap-6 border-t border-ink/10 pt-6">
            {about.highlights.map((h) => (
              <div key={h.label}>
                <dt className="text-xs font-semibold uppercase tracking-wide text-ink-soft">
                  {h.label}
                </dt>
                <dd className="mt-1 font-display text-lg text-ink">{h.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
